import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';
import {NgbCarousel, NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {MatTabGroup} from '@angular/material/tabs';
import {TranslateService} from '@ngx-translate/core';


// declare var test :any;
@Component({
  selector: 'app-home',
  templateUrl: 'pageNotFound.component.html',
  styleUrls: ['pageNotFound.component.css']
})
export class PageNotFoundComponent implements OnInit {



  constructor() { }


  ngOnInit() {
// new test();
  }


}
